import React from 'react';
import {
  Button,
  Divider,
  Header,
  Icon,
  Item,
} from 'semantic-ui-react';
import { DocumentRejections } from '../contracts/contractManagement/DocumentRejections'
import PropTypes from 'prop-types';

export const DealerDocUploader = (props) => {
  const {
    doc,
  } = props;

  return (
    <div>
      <Item.Group divided style={{ marginBottom: '0' }}>
        <Item>
          <Item.Image
            as={() => (
              <Icon
                size="huge"
                name={doc && doc.filename ? 'file' : 'question'}
                color={doc && doc.filename ? (doc.accepted ? 'green' : 'red') : 'red'}
                style={{
                  marginRight: '12px'
                }}
              />
            )}
          />
          <Item.Content>
            <Item.Header content={props.header} />
            <Item.Meta content={doc && doc.filename ? (doc.accepted ? 'Accepted' : 'Under Review') : 'Missing'} />
            {
              doc && doc.expiration_date_formatted &&
                <Item.Meta
                  content={`Expires ${doc.expiration_date_formatted}`}
                />
            }
            <Item.Description style={{ marginTop: '15px' }}>
              {
                props.sampleUrl &&
                  <p>
                    <Icon name="download" /><a href={props.sampleUrl} target="blank">Download form</a>
                  </p>
              }
              {
                doc && doc.rejection_notes && doc.rejection_notes.find(f => !f.fixed) &&
                  <div style={{ marginTop: '25px' }}>
                    <DocumentRejections
                      divider={false}
                      rejections={doc.rejection_notes}
                      title={`${props.header} Rejections`}
                    />
                  </div>
              }
            </Item.Description>
            <Item.Extra style={{ marginTop: '25px' }}>
              {
                doc && doc.filename
                  ? (
                      <div>
                        <Button
                          color="blue"
                          size="tiny"
                          basic
                          icon="download"
                          title="Download"
                          href={props.url}
                          download={`${doc.filename}`}
                        />
                        <Button
                          color="red"
                          size="tiny"
                          basic
                          icon="trash"
                          title="Delete"
                          onClick={e => props.onDocRemove(e, props.docType)}
                        />
                      </div>
                    )
                  : (
                      <div>
                        <Button
                          as="label"
                          content="Upload"
                          basic
                          color="blue"
                          size="tiny"
                          basic
                          htmlFor={props.docType}
                          disabled={
                            props.children
                              ? (
                                  props.doc && props.doc.expiration
                                    ? false
                                    : true
                                )
                              : false
                          }
                        />
                        <input
                          hidden
                          id={props.docType}
                          accept=".jpeg,.jpg,.gif,.png,.pdf"
                          name={props.docType}
                          type="file"
                          onChange={e => props.onDocUpload(e)}
                        />
                      </div>
                    )
              }
            </Item.Extra>
          </Item.Content>
        </Item>
      </Item.Group>
      <Divider hidden />
    </div>
  );
}

DealerDocUploader.propTypes = {
  doc: PropTypes.shape({
    accepted: PropTypes.bool,
    expiration: PropTypes.string,
    filename: PropTypes.string,
    id: PropTypes.number,
    rejection_notes: PropTypes.array,
  }),
  docType: PropTypes.string,
  header: PropTypes.string,
  onDocRemove: PropTypes.func,
  onDocUpload: PropTypes.func,
  // onExpirationUpdate: PropTypes.func,
  url: PropTypes.string,
};
